export enum ReportMetaFieldTypes {
    RANGE = "range",
    LIST = "list",
    VALUE = "value",
}